import { brandThemeVars } from '@/shared/lib/color/theme'
import {
  resolveTopbarBackground,
  resolveTopbarSkin,
  resolveTopbarVariant
} from '@/shared/ui/Layout/chrome/topbarTheme'

import type { TenantIdentity } from './identity'

/**
 * Escritos pelo bootstrap e lidos pela topbar como valor de partida: a barra
 * nasce com a superfície do evento, e quando o evento confirmado chega com o
 * mesmo modo o valor calculado é idêntico ao pintado — nada repinta.
 */
export const TOPBAR_SURFACE_VARS = {
  background: '--gami-topbar-bg',
  backgroundImage: '--gami-topbar-bg-image',
  backgroundRepeat: '--gami-topbar-bg-repeat'
} as const

/** Onde o React lê, de forma síncrona, o que o bootstrap aplicou. */
export const APPLIED_IDENTITY_GLOBAL = '__evnttzTenantIdentity'

/**
 * Puro por desenho — sem DOM e sem `window` — para que o mesmo código rode no
 * script inline, no bundle e no teste. Identidade ausente devolve mapa vazio:
 * não escrever preserva a âncora da folha até haver cor do evento.
 */
export function tenantIdentityStyleVars(
  identity: TenantIdentity | null | undefined
): Record<string, string> {
  if (!identity) return {}

  const vars: Record<string, string> = {}

  if (identity.color) Object.assign(vars, brandThemeVars(identity.color))

  const variant = resolveTopbarVariant(identity.topbar_mode)
  const background = resolveTopbarBackground({
    variant,
    mode: identity.topbar_mode,
    textureUrl: identity.topbarTextureUrl,
    colorLight: identity.topbar_color_light,
    colorDark: identity.topbar_color_dark
  })

  if (background?.backgroundColor) {
    vars[TOPBAR_SURFACE_VARS.background] = String(background.backgroundColor)
  }

  if (background?.backgroundImage) {
    vars[TOPBAR_SURFACE_VARS.backgroundImage] = String(
      background.backgroundImage
    )
    vars[TOPBAR_SURFACE_VARS.backgroundRepeat] = String(
      background.backgroundRepeat ?? 'repeat'
    )
  }

  return vars
}

/** O skin que a topbar assume antes de o evento confirmado chegar. */
export function tenantIdentitySkin(
  identity: TenantIdentity | null | undefined
) {
  const mode = identity?.topbar_mode ?? null

  return resolveTopbarSkin(resolveTopbarVariant(mode), mode)
}
